module.exports = __webpack_public_path__ + "img/DE01341.da679ea7.png";